import apiShipper from '../services/apiShipper';

export async function clientesPagadores(pagadores = []) {
  if (pagadores) {
    const { data } = await apiShipper.get('clientes/tmov', {
      params: {
        id_clientes: pagadores,
        size: 0,
      },
    });

    const clientes = data.content;

    return clientes.sort((a, b) =>
      a.razao_social.localeCompare(b.razao_social)
    );
  }
  return pagadores;
}
